import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT =
  process.env.REACT_APP_ENDPOINT + "/api/x-admin/balance-requested";

const updateRequestedBalanceStatus = async (id,data) => {
  return await axios.put(`${API_ENDPOINT}/${id}`, data, {
    withCredentials: true,
    headers: { ...authHeader(), Accept: "application/json" },
  });
};
const getRequestedBalances = async (page = 1) => {
  return await axios.get(`${API_ENDPOINT}?page=${page}`, {
    withCredentials: true,
    headers: { ...authHeader(), Accept: "application/json" },
  });
};

const requestedBalanceServices = {
  updateRequestedBalanceStatus,
  getRequestedBalances,
};
export default requestedBalanceServices;
